export function filterProductBy(arr, itemField, toMatchedField) {
    return arr.filter(item => item[itemField] === toMatchedField);
}

export function filterMultiServiceCurrentBookingState(state, getters) {
    const otherBookingDetails = getters.GET_ACTIVE_MULTIPLE_SERVICE_OTHER_BOOKING_STATE
        .find(bookingState =>
            bookingState.service_group_id === getters.GET_ACTIVE_SERVICE_GROUP.service_group_id
            && bookingState.service_setting_id === getters.GET_ACTIVE_SERVICE_SETTING.service_setting_id);
    if (otherBookingDetails) {
        return otherBookingDetails.selectedMultipleCollectionSetting;
    } else {
        return null;
    }
}

export function parseNumberFields(obj) {
    const d = { ...obj };
    for (const key in d) {
        if (d.hasOwnProperty(key)) {
            if (['product_pricing_price1', 'product_pricing_price2'].includes(key)) {
                d[key] = parseFloat(d[key]);
            }
        }
    }
    return d;
}
// validate the special option in case required setting is enabled
export function validateRequiredSpecialOptions(getters) {
    const selectedBookingProducts = getters.GET_BOOKING_PRODUCTS;
    const selectedSpecialOptions = getters.GET_BOOKING_STATE.selectedSpecialOptions || {};
    const wasteStreamList = getters.GET_LOADED_WASTE_STREAMS || [];
    const activeServiceSetting = getters.GET_ACTIVE_SERVICE_SETTING;
    // find required option but it's not checked
    const requiredToCheckedOptions = wasteStreamList.filter((wastestream) => {
        // ignore if current wastream does not belongs to active service
        if (wastestream.service_setting_id !== activeServiceSetting.service_setting_id) return;

        // find if parent is enable but the special option is not choosen
        if (wastestream.special_waste_stream_enable && wastestream.special_waste_stream_required == true) {
            if (wastestream.dependency_waste_stream_setting_id) {
                if (selectedBookingProducts.find((e) => e.waste_stream_setting_id === wastestream.dependency_waste_stream_setting_id)) {
                    if (!selectedSpecialOptions[wastestream.waste_stream_setting_id]) {
                        return wastestream;
                    }
                }
            } else {
                if (!selectedSpecialOptions[wastestream.waste_stream_setting_id]) {
                    return wastestream;
                }
            }
        }

    });
    return requiredToCheckedOptions.length > 0
        ? {
            result: false,
            message: requiredToCheckedOptions[0].special_waste_stream_required_message || 'Required options have not been selected.'
        }
        : { result: true,
            message: ''
        };
}
